<div class="popup" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="space-around stretch" class="prompt-dialog">
        <div class="body">
            <div *ngIf="!hideHeader" class="header" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="title">{{ title }}</div>
                <div class="close-button" (click)="close()">
                    <i class="ju ju-close"></i>
                </div>
            </div>
            <div class="text" [innerHTML]="body"></div>
            <div *ngIf="!hideActions" class="buttons" fxLayout="row" fxLayoutAlign="space-between center">
                <button *ngIf="closeActionEnabled" (click)="close()" class="cancel">{{ cancelAction }}</button>
                <button (click)="confirm()" class="save">{{ confirmAction }}</button>
            </div>
        </div>
    </div>
</div>
